exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attach-btn[data-v-28f285c8]{background:transparent;border:none;z-index:99;padding-right:.5rem;position:absolute;left:-2.5rem;top:.3rem}.attach-btn:hover label[data-v-28f285c8],.attach-btn:hover svg[data-v-28f285c8],.attach-btn[data-v-28f285c8]:hover{cursor:pointer}.comment-input[data-v-28f285c8]{resize:none;overflow:hidden}.custom-select[data-v-28f285c8]{min-width:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28f285c8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CommentForm.vue
// module id = OZzJ
// module chunks = 1